import _get from 'lodash/get';

import isNode from '../modules/ajio-util/isNode';

export function getAffiseConversionId(productId, orderId) {
  return `${orderId}_${productId}`;
}

export function deleteAffiseDataIfExpired() {
  if (isNode()) {
    return false;
  }
  const storedDate = localStorage.getItem('affAw');
  if (storedDate) {
    const expiryDate = new Date(storedDate);
    if (new Date() >= expiryDate) {
      localStorage.removeItem('affAw');
      localStorage.removeItem('affID');
      localStorage.removeItem('affQuery');
      return true;
    }
  }
  return false;
}

export function getAffisePixels({ products, items, orderId, afsecure, channelType }) {
  if (isNode()) {
    return [];
  }

  if (deleteAffiseDataIfExpired()) {
    return [];
  }

  try {
    const affQueryJSON = localStorage.getItem('affQuery');
    const affClickID = localStorage.getItem('affID');
    const customerTypeDataString = localStorage.getItem('customerTypeData');
    const customerTypeData = customerTypeDataString ? JSON.parse(customerTypeDataString) || {} : {};
    const { customerType } = customerTypeData;
    const affQuery = JSON.parse(affQueryJSON) || {};
    const pixels = [];

    if (affClickID && affQuery.pid && affQuery.offer_id) {
      products.forEach((productEntry, index) => {
        const queryParams = [];
        const { product = {}, totalPrice, quantity, offers, shippingChargePromoAmt } = productEntry;
        const { code, brandName, catalogName, verticalName, brickName, brickCategory } = product;
        const revenue = shippingChargePromoAmt + totalPrice.value;
        const price = revenue / quantity;
        const voucherCodeArray = _get(items, `[${index}].offers.appliedVouchers`, []);
        const voucherCode = voucherCodeArray.map(v => v.code).join(',');
        const currency = totalPrice.currencyIso;

        const queryObject = {
          afclick: affClickID,
          offer_id: affQuery.offer_id,
          afid: getAffiseConversionId(code, orderId),
          afprice: revenue,
          afstatus: 5,
          afsecure: afsecure,
          afcurrency: currency
        };

        for (const key in queryObject) {
          queryParams.push(`${key}=${encodeURIComponent(queryObject[key] || '')}`);
        }

        /**
         * Custom parameters
         */
        const customParams = [
          affQuery.utm_source,
          affQuery.utm_medium,
          affQuery.utm_campaign,
          price, // Price per item
          voucherCode,
          catalogName, // Catalogue id – AJIO_Street, AJIO_Regular, AJIO_Luxe
          customerType, // Customer type – New customer  (current order is the first order on AJIO), Repeat customer (customer has placed >=1 orders on AJIO before the current order)
          quantity,
          channelType, // Channel Type - Desktop/Mobile
          brandName, // Brand name
          brickName, // Brick – Jeans/Tshirts/Dupattas/Kurtas/Kurtis & Tunics
          verticalName, // Vertical – Clothing/Footwear/Accessories/Western Wear/Inner Wear
          brickCategory // Segment – Men/Women/Boys/Girls/Indie/Home&Kitchen
        ];

        customParams.forEach((element, index) => {
          queryParams.push(`custom_field${index + 1}=${encodeURIComponent(element) || ''}`);
        });

        const queryString = queryParams.join('&');

        console.log(
          `https://ajios.g2afse.com/success.jpg?success=1&${queryString}`,
          'affiseData_order_placement'
        );

        pixels.push(`//ajios.g2afse.com/success.jpg?success=1&${queryString}`);
      });

      return pixels;
    }
  } catch (e) {
    // console.log(e); // Handle error gracefully
    return [];
  }
  return [];
}

export function getAffiliateData(deliverableItems, cartId) {
  if (isNode()) {
    return null;
  }
  const affQueryJSON = localStorage.getItem('affQuery') || '{}';
  const affQuery = JSON.parse(affQueryJSON) || {};
  const items = (deliverableItems || []).map(({ code }) => getAffiseConversionId(code, cartId));
  if (!items.length || !affQuery.clickid) {
    return null;
  }
  const affiliateData = {
    clickId: affQuery.clickid,
    affiliateId: affQuery.pid,
    conversionId: items.join(','),
    attributionWindow: affQuery.attribution_window,
    returnCancellationWindow: affQuery.return_cancellation_window,
    offerId: affQuery.offer_id,
    utmSource: affQuery.utm_source,
    utmMedium: affQuery.utm_medium,
    utmCampaign: affQuery.utm_campaign
  };

  return affiliateData;
}
